module.exports = __webpack_public_path__ + "img/H1.07324f6b.png";